<template>
  <el-drawer
    custom-class="drawer-custom-class"
    append-to-body
    :close-on-press-escape="false"
    title="无鉴定能力目录"
    size="640px"
    :visible.sync="visible"
    direction="rtl"
    @closed="onClosed">
    <div
      v-loading="loading"
      class="drawer-wrap">
      <!-- <div style="margin-bottom: 10px;">
        <el-button
          type="primary"
          @click="handleCurrentChange(1)">刷新</el-button>
      </div> -->
      <el-form
        label-width="90px"
        @submit.native.prevent>
        <el-row
          :gutter="10"
          type="flex">
          <el-col :span="10">
            <el-form-item label="品牌名称:">
              <brand-remote-select v-model="config.brandId" />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="类目名称:">
              <class-remote-select v-model="config.class4Id" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              label=""
              label-width="0">
              <el-button
                type="primary"
                @click="handleCurrentChange(1)">刷新</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          min-width="100"
          label="二级类目"
          prop="class4Name"></el-table-column>
        <el-table-column
          min-width="200"
          label="品牌名称"
          prop="brandName"></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          :width="70">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="deleteItem(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </div>
  </el-drawer>
</template>
<script>
import Online from '@/service/online'
import BrandRemoteSelect from '@/pages/appraisal/brand-remote-select.vue'
import ClassRemoteSelect from '@/pages/appraisal/class-remote-select.vue'
export default {
  name: 'NoAbilityModal',
  components: { BrandRemoteSelect, ClassRemoteSelect },
  data() {
    return {
      visible: false,
      loading: false,
      config: { staffId: null, pageNum: 1, pageSize: 10, brandId: null, class4Id: null },
      list: [],
      total: 0
    }
  },
  methods: {
    addItem() {
      this.$refs.price.init()
    },
    deleteItem(row) {
      this.$confirm('确定要删除该无鉴定能力项吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Online.deleteabilityblacklist({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    onClosed() {
      this.config = { ...this.config, ...this.$options.data().config }
      this.list = []
      this.total = 0
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Online.getabilityblacklists({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(config) {
      this.visible = true
      this.config = { ...this.config, ...config }
      this.fetchList()
    }
  }
}
</script>
